import Home from '@/components/screens/home/Home';
import { NextPage, GetStaticProps } from 'next';
import { API_URL, REVALIDATE_TIME } from '@/helpers/variables';
import { IBookPage } from '@/interfaces/booksPage.interface';
import { IAdvertisingBlock } from '@/interfaces/advertisingBlock';
import { IPodcastPage } from '@/interfaces/podcastsPage.interface';
import { IPopularBooks } from '@/interfaces/popularBooks.interface';

interface IHomePage {
  popularBooks: IPopularBooks;
  newBooks: IBookPage;
  advertisingBlock: IAdvertisingBlock;
  podcastsBlock: IPodcastPage;
  freeBooks: IBookPage;
}

const HomePage: NextPage<IHomePage> = ({ popularBooks, newBooks, advertisingBlock, podcastsBlock, freeBooks }) => {
  return <Home popularBooks={popularBooks} newBooks={newBooks} advertisingBlock={advertisingBlock} podcastsBlock={podcastsBlock} freeBooks={freeBooks} />;
};

export const getStaticProps: GetStaticProps = async () => {
  const [popularRes, newRes, advertisingBlockRes, podcastsBlockRes, freeBooksRes] = await Promise.all([
    fetch(`${API_URL}main-page/main-page-popular-books`),
    fetch(`${API_URL}satellite/books/news?page=1&page_size=6`),
    fetch(`${API_URL}advertising_block`),
    fetch(`${API_URL}satellite/podcast/podcast?page=1&page_size=10&sort_field=rating&sort_reversed=true`),
    fetch(`${API_URL}satellite/books?free_book=true&page=1&page_size=8&sort_reversed=true`),
  ]);

  const [popularBooks, newBooks, advertisingBlock, podcastsBlock, freeBooks] = await Promise.all([popularRes.json(), newRes.json(), advertisingBlockRes.json(), podcastsBlockRes.json(), freeBooksRes.json()]);

  return { props: { popularBooks, newBooks, advertisingBlock, podcastsBlock, freeBooks }, revalidate: REVALIDATE_TIME };
};

export default HomePage;
